export default "__VITE_ASSET__DHDziHwh__"